module.exports = __webpack_public_path__ + "img/1762008070501-mZptLZBH.3059eab9.png";